export { default as Icon } from './icon';

// The ./library module is generated upon building this package. Make sure you
// run `build`, otherwise tools won't be able to resolve this import.
export * from './library';
